import { baseFetch } from './base.js';


const basePath = 'trade-session';

export const getLatestTradeSession = () => {
  return baseFetch(`${basePath}/latest`, 'GET');
}